var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 13 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 27.0908V31.0076C10.4321 30.9537 7.94817 31.2332 5.4782 30.5445C2.67252 29.7639 0.856018 28.0211 0.318461 25.1044C0.134613 24.1042 0.0187086 23.084 0.0187086 22.0639C-0.0152634 17.4583 0.00472012 0.277496 0.0187086 0H5.18445C5.18445 0.0738657 5.18445 3.4677 5.18445 7.51434H12.8701V11.5211H5.18445C5.16446 15.1185 5.16446 18.5942 5.18445 20.2412C5.18445 21.0777 5.27237 21.9142 5.38828 22.7307C5.73599 25.3839 7.11086 26.6815 9.76667 26.9271C10.8278 27.0149 11.9029 27.0349 13 27.0908Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.03c01c7403371fdb1913ba6665f007b7.svg";
export { ForwardRef as ReactComponent };